import { B03HeroFeaturedBannerProps } from './B03HeroFeaturedBanner';
import { HeroFeaturedBannerProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { ReactElement } from 'react';
import { getKvpValue } from 'src/shared/field-utils';

export function CreateHeroFeaturedBannerModel(
  props?: B03HeroFeaturedBannerProps
): HeroFeaturedBannerProps {
  const { params, fields } = props || {};
  const { renderText, renderLink } = useConditionalRendering();

  return {
    backgroundGradientLevel: getDroplink(params?.BackgroundGradientLevel, '0'),
    backgroundImage: {
      src: fields?.BackgroundImage?.value?.src ?? '',
      alt: (fields?.BackgroundImage?.value?.alt as string) ?? '',
    },
    firstCTAIcon: getKvpValue(fields?.FirstCTAIcon),
    firstCTALink: renderLink(fields?.FirstCTA) as ReactElement,
    headline: renderText(fields?.Headline, { required: true }),
    mobileBackgroundImage: fields?.MobileBackgroundImage?.value?.src,
    secondCTAIcon: getKvpValue(fields?.SecondCTAIcon),
    secondCTALink: renderLink(fields?.SecondCTA) as ReactElement,
    taglineBottom: renderText(fields?.TaglineBottom),
    taglineTop: renderText(fields?.TaglineTop),
  };
}
